'use client';

import React, { createContext, useContext } from 'react';
import { EMPTY_EXPERIMENT_REQUEST_STATE, ExperimentRequestState } from '@/utils/experiment-helper';

const ExperimentContext = createContext<ExperimentRequestState>(EMPTY_EXPERIMENT_REQUEST_STATE);

interface ExperimentProviderProps {
  state: ExperimentRequestState;
  children: React.ReactNode;
}

/**
 * Publishes the middleware-computed experiment request state to the client tree.
 *
 * The state is serialized once per document request. The root layout does not re-render on soft
 * navigation, so it stays frozen for the lifetime of the document — acceptable because the bucketing
 * is a pure function of the session id (it would recompute to the same arm anyway) and because ad
 * clicks, the one case where `?var` matters, always arrive as document requests.
 */
export function ExperimentProvider({ state, children }: Readonly<ExperimentProviderProps>) {
  return <ExperimentContext.Provider value={state}>{children}</ExperimentContext.Provider>;
}

export function useExperiment(): ExperimentRequestState {
  return useContext(ExperimentContext);
}
